import { Dashboard as DashboardPage } from './dashboard/dashboard'
import { ReferralsList as ReferralsListPage } from './referrals-list/referrals-list'
import { Earnings as EarningsPage } from './earnings/earnings'

export const AffiliateStack = {
  DashboardPage,
  ReferralsListPage,
  EarningsPage,
}
